/**
 * Questa è la classe per il Repository della Sessione
 * Quindi tutte le richieste ai servizi che c'entrano con la Sessione andrebbero messe qui
 *
 */

import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import moment from "moment";

import { getResponseMessage } from "core/interfaces/data/Base";
import {
	ICreateSession,
	ICreateSessionProps,
	ISession,
	IStartSession,
	IStartSessionProps,
	IStopSession,
	IStopSessionProps,
} from "core/interfaces/util/ISession";

// questo serve per fare la richiesta una seconda volta se in caso la prima non va a buon fine
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;

class SessionRepository {
	/**
	 * Metodo che manda la richiesta per la crezione della sessione
	 * Le props, ovvero i parametri che servono per fare la richiesta li dichiaro
	 * con una interfaccia che contiene i campi che servono per chiamare il servizio
	 * Nella richiesta di Axios gli do il tipo così puoi usare l'intellisense
	 * Rispetto ai dati che hai messo nella Response crei l'interfaccia che mappa quei campi
	 */
	async createSession(props: ICreateSessionProps): Promise<ISession | undefined> {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/SessionCreate`;

			const res = await axios.post<ICreateSessionProps, AxiosResponse<ICreateSession>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			const { IdSessione, ExpireIn } = res.data;

			const expireDate = moment().add(ExpireIn, "minutes").toDate();

			const session: ISession = {
				idSessione: IdSessione,
				expiredIn: expireDate,
			};

			return session;
		} catch (err) {
			console.log(err);
		}
	}

	/**
	 * Metodo che manda la richiesta per notificare che il countdown della sessione è partita effettivamente
	 * Le props, ovvero i parametri che servono per fare la richiesta li dichiaro
	 * con una interfaccia che contiene i campi che servono per chiamare il servizio
	 * Nella richiesta di Axios gli do il tipo così puoi usare l'intellisense
	 * Rispetto ai dati che hai messo nella Response crei l'interfaccia che mappa quei campi
	 */
	async StartSession(props: IStartSessionProps): Promise<ISession | undefined> {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/SessionStart`;
			const res = await axios.post<IStartSessionProps, AxiosResponse<IStartSession>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			const { IdSessione, ExpireIn } = res.data;

			const expireDate = moment().add(ExpireIn, "minutes").toDate();

			const session: ISession = {
				idSessione: IdSessione,
				expiredIn: expireDate,
			};

			return session;
		} catch (err) {
			console.log(err);
		}
	}

	/**
	 * Metodo che manda la richiesta per notificare che il countdown della sessione è terminato effettivamente
	 * Le props, ovvero i parametri che servono per fare la richiesta li dichiaro
	 * con una interfaccia che contiene i campi che servono per chiamare il servizio
	 * Nella richiesta di Axios gli do il tipo così puoi usare l'intellisense
	 * Rispetto ai dati che hai messo nella Response crei l'interfaccia che mappa quei campi
	 */
	async EndSession(props: IStopSessionProps) {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/SessionEnd`;
			const res = await axios.post<IStopSessionProps, AxiosResponse<IStopSession>>(url, props);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			return res.data.Result;
		} catch (err) {
			console.log(err);

			return false;
		}
	}
}
var SessionRep =new SessionRepository()
export default SessionRep;
